export interface IEntityLightWeight {
  entityUid: string;
  name: string;
}
